// default-translations.ts
var dataViewTranslations = {
  "data-view": {
    export: ["Exportieren", "export"],
    search: ["Suchen", "search"],
    save: ["Speichern", "save"],
    addNewField: ["Neues Feld hinzuf\xFCgen", "add new field"],
    chooseNewFieldType: ["Feld-Typ ausw\xE4hlen", "choose field type"],
    add: ["Hinzuf\xFCgen", "add"],
    delete: ["L\xF6schen", "delete"],
    sort: ["Sortieren", "sort"]
  },
  field: {}
};
export {
  dataViewTranslations
};
